<template>
  <div>
    <div class="table">
      <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
        <el-form-item label="简介标题" prop="title">
          <el-input v-model="saveData.name" placeholder="请输入标题"></el-input>
        </el-form-item>

      </el-form>
      <div class="dialog-Btn">
        <el-button size="small" @click="closedialog">取消</el-button>
        <el-button size="small" type="primary" @click="updateData">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addProgrammeCustomDetail } from "@/api/pageTemplate.js";

export default {
  name: 'title_ecit',
  props: {
    closedialog: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      form: {},
      saveData: {},
    }
  },
  mounted () {
    this.saveData = this.$store.state.pageTemplateData.customDetailList[3]
  },
  methods: {
    updateData () {
      addProgrammeCustomDetail(this.saveData).then(res => {
        if (res.data == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },
  }
}

</script>
<style  lang="scss" scoped>
.dialog-Btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>